var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTotalRunsPassed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 16,
    rx: 2.4,
    fill: "#EEFCF8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.55 5.53125C12.7375 5.71875 12.7375 6 12.55 6.16875L7.6 11.1187C7.43125 11.3062 7.15 11.3062 6.98125 11.1187L4.43125 8.56875C4.24375 8.4 4.24375 8.11875 4.43125 7.93125C4.6 7.7625 4.88125 7.7625 5.05 7.93125L7.3 10.1812L11.9313 5.53125C12.1 5.3625 12.3813 5.3625 12.55 5.53125Z",
    fill: "#0B654A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalRunsPassed);
export default __webpack_public_path__ + "static/media/total-runs-passed.c07f4fcc27a89c613019e63fc003c7fa.svg";
export { ForwardRef as ReactComponent };